import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import fr from './fr.json';
import en from './en.json';
import ar from './ar.json'; // -arabic-

/**
 * -i18n- Les textes sont DANS l'application (pas téléchargés) : la langue enregistrée est prête
 * dès le premier affichage -> jamais de français puis anglais, jamais de clés brutes.
 */
export class BundledTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    return of(lang === 'en' ? en : lang === 'ar' ? ar : fr);
  }
}
